import { faBars, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

const Header = ({sideBar,setSideBar}) => {
    return (
        <header id="header" className="header fixed-top d-flex justify-content-between">

            <div className="d-flex align-items-center justify-content-between">
                <span 
                    className="bar-btn" 
                    style={{fontSize: 20,cursor: "pointer"}}
                    onClick={()=>{
                        setSideBar(sideBar?false:true)
                    }}
                >
                    <FontAwesomeIcon
                        icon={faBars}                        
                    />
                </span>
            </div>

            <div className="d-flex align-items-center justify-content-center">
                <a href={process.env.REACT_APP_PATH_APP}>
                    <span className="d-block" style={{fontSize: 20}}>
                        <FontAwesomeIcon
                            icon={faHome}
                        />
                    </span>
                </a>
            </div>

            <div className="d-flex align-items-center justify-content-between">
                <span style={{fontWeight: "bold",fontSize: 14, paddingRight: 20}}>
                    Portal de aplicaciones - Versión: 1.05
                </span>
            </div>

        </header>

    )
}

Header.propTypes = {
    setSideBar: PropTypes.func,
    sideBar: PropTypes.bool
}

export default Header;